import React from 'react'
import '../styles/article.css'

const EchoesCH10 = () => {
    return (
        <div className='echoes-chapter'>
            <h1 className='ec-h1'>Chapter 10: Raising the Roof</h1>


            <p>We didn’t leave the auditorium during the break. Instead, we stood, stretched, and
                prepared ourselves for what we knew would be the most intense division of the
                competition. This was the one everyone came to see—the schools with over 3,000
                students, the giants of the show choir world. Tom’s choir from Indiana would
                perform first, followed by a choir from California (who had held the championship
                title for three consecutive years), then one from Arizona, and one more from
                California.</p>
            <p>The stakes were high, and as I looked at the lineup, my stomach twisted with nerves.
                For years, I’d watched Tom’s choir pour their hearts into making it to Nationals. But
                the last two years had been humbling—placing last in this division and never
                advancing to finals. Frank’s voice lingered in my thoughts, his golden rule echoing
                like a quiet drumbeat: California always wins.</p>
            <p>But as I glanced at the stage, a flicker of hope stirred in me. Maybe, just maybe, this
                year would be different.</p>

            <p>Barbara reached over, her touch grounding me as she gave my shoulders a quick
                squeeze. “Stretch it out,” she teased, smiling as she leaned over to do the same for
                Cora. We laughed softly, the sound more for ourselves than for any audience. These
                small moments of connection helped steady the nerves.</p>
            <p>Then the MC returned, his voice cutting through the low hum of anticipation. “The
                judges are ready. Now, let us begin with the show choir from Indiana.”</p>
            <p>The applause was immediate, and I shot to my feet, clapping with everything I had.
                Barbara and Cora joined in, their cheers rising alongside mine. But when the choir
                stepped onto the stage, my hands froze mid-clap.</p>

            <p>It was like nothing I had ever seen before.</p>
            <p>Tom had warned me I’d be surprised by their National’s performance, but this... this
                was beyond anything I could have imagined.</p>
            <p>I’d seen their show before, back in Indiana, where they’d performed in simple
                overalls and work shirts, a nod to our town’s hardworking roots. But now, they
                emerged in traditional Amish attire—the boys with black hats, the girls with their
                hair swept neatly into bonnets. The theme was Build a House, and the stage was
                transformed into a makeshift construction site, complete with lumber, saws, pegs,
                and hammers.</p>

            <p>The opening chords of Andrew Lippa’s “Raise the Roof” filled the auditorium, and
                the transformation was complete. This wasn’t just a choir—it was theater, art, and
                energy fused into one.</p>
            <p>The juxtaposition of their traditional costumes and the pulsating beat of the music
                was mesmerizing. The choreography was bold, almost defiant, as if daring the
                audience to challenge the audacity of what they were witnessing. The transitions
                between songs were seamless, flowing from the Isley Brothers’ “Work to Do” to
                David Ferguson’s “House Build.” Each movement, each note, was precise, but it was
                the heart behind the performance that caught me.</p>
            <p>Then came the ballads.</p>



            <p>“My Home” by Myles Smith began softly, the choir’s voices blending in perfect
                harmony, the lyrics swelling with longing and pride. By the time they transitioned
                into “Down to the River to Pray,” the room felt like a sanctuary. The haunting
                simplicity of their voices, unaccompanied and raw, filled the space with an almost
                spiritual energy.</p>
            <p>And yet, they didn’t stop there. The performance rose again, closing with the energy
                and joy of “Raise the Roof,” bringing the audience to its feet before the final note
                even finished echoing.</p>
            <p>Cora leaned over, her face a mixture of awe and disbelief. “Well, that was... different.”
                I shook my head, unable to form a coherent thought. “I’m speechless,” I finally
                managed. “I had no idea.”</p>

            <p>Barbara, always the boldest among us, declared, “That’s the winning show.
                Avant-garde. Bravo, bravo, bravo!”</p>
            <p>She wasn’t wrong. The performance had been flawless. In my mind, I could already
                see Frank shaking his head in amazement, them texting me: Damn, they just beat
                the Californians!</p>
            <p>The choir took a bow, their breaths visible under the lights from the sheer exertion
                of their effort. And then, as if to anchor the performance in something greater than
                themselves, they sang an a cappella benediction:</p>

            <p><i>“If the Lord doesn’t build the house, the laborers labor in vain. Amen.”</i></p>
            <p>The simplicity of those words, paired with the purity of their voices, hit me harder
                than I expected. Tears pricked at my eyes as the applause erupted once more, louder
                and more sustained than anything I’d ever heard in this theater.</p>
            <p>I found myself screaming, clapping until my hands ached, wishing for the first time
                that I’d brought a cowbell like some of the other parents. The standing ovation
                wasn’t just immediate—it was relentless. No one sat down, no one stopped. The
                pride in the room was palpable, and I realized it wasn’t just our town cheering for
                Tom’s choir—it was everyone.</p>

            <p>If this had been any other performance, the choir would have returned to the stage
                for an encore. But this was a competition, and there were rules to follow. It took the
                MC several minutes to calm the audience, finally stepping forward with a smile to
                quiet the chaos.</p>
            <p>“And now,” he said, his voice warm but commanding, “we must continue the
                competition with a choir from Southern California.”</p>
            <p>As the lights dimmed again, I sat down slowly, my heart still racing. For the first
                time, I allowed myself to believe. Maybe this year, we could win.</p>



            <p>The award-winning show choir from Southern California stormed the stage with
                Beetlejuice, and from the moment the lights dimmed, you knew they were swinging
                for the fences. Frank had nailed it again—everything about their performance was
                ridiculously over-the-top. The sets looked like they’d been airlifted straight from
                Broadway, every detail immaculate. But the real show was watching their crew
                assemble it all in less than five minutes. These weren’t your typical show choir dads,
                the kind who spend their weekends balancing props in one hand and a burger in the
                other. No beer bellies and knee braces here—these guys looked like they
                moonlighted as CrossFit instructors or pit crew members at the Daytona 500.
                Watching them work made you wonder if assembling sets counted as cardio.</p>
            <p>The costumes were just as extravagant, with three dramatic wardrobe changes over
                the course of the show. And then there was the smoke. Oh, the smoke. They had
                machines cranking out so much fog it was like someone had thrown a rave in a
                cemetery. From our safe vantage point in the balcony, we had a perfect view, but the
                folks in the first six rows weren’t so lucky. By the time the second number started,
                they were practically swimming in the stuff, squinting and waving their hands in
                front of their faces like they were trying to survive a haunted house gone wrong. I
                half-expected the judges to whip out flashlights just to find the stage.</p>
            <p>Still, I have to admit, the music was impeccable. Their six-part harmonies were as
                polished and Californian as a beachside sunset, each note landing with
                jaw-dropping precision. Their choreography was straight from Broadway’s playbook,
                a seamless flow of energy and style. Every spin, every kick—it was all razor-sharp. It
                was clear they weren’t just performing; they were making a statement. They wanted
                that national trophy, and they weren’t about to leave anything to chance.</p>

            <p>As their final note echoed through the auditorium, the crowd erupted into wild
                cheers. Fans shot out of their seats, clapping and hollering like they’d just witnessed
                the Second Coming. Beside me, Barbara leaned over, smirking. “How do you get
                excited over dead people singing?” she whispered. The words had barely escaped her
                mouth before her face went pale, and she clapped her hands over her lips. “Oh no,”
                she gasped. “I’m so sorry. I shouldn’t have said that—especially not this week.”</p>
            <p>I couldn’t help it—I burst out laughing, pulling her into a quick hug. “The only dead
                person I’d enjoy hearing sing is Frank,” I teased, “and only if he sang, I’ll Be Loving
                You Always. And absolutely not Beetlejuice.”
                Barbara let out a relieved laugh, and soon we were giggling like kids caught talking
                in church. Then Cora chimed in, her voice cutting through our laughter. She sat
                back with her arms crossed, her Iowa pragmatism on full display. “If those judges
                give them first place again, I swear they’ve been inhaling more smoke than the
                audience. Or maybe they need deworming and I sure know how to make that
                happen.”</p>
            <p>That sent us right over the edge. We laughed so hard tears sprang to our eyes. In that
                moment, surrounded by fog and show choir chaos, the weight of everything else
                lifted, if only for a little while. Because sometimes, it’s not the spectacle onstage that
                matters—it’s the people sitting beside you, making everything just a little bit lighter.</p>

            <p>The next three show choirs each brought something memorable to the stage, though
                their styles were so distinct it felt like trying to compare paintings to poetry. The
                choir from Arizona opened their show, Rain, with a soloist whose voice carried such
                raw emotion it was like the air in the auditorium shifted. She sang “Soon It’s Gonna
                Rain” with a tone so rich, so achingly beautiful, I could feel the song settling
                somewhere deep in my chest. She reminded me of Barbra Streisand—not just in
                sound but in the way she held the room, as though the world outside didn’t exist.</p>
            <p>Then the choir joined in, their voices weaving a delicate a cappella harmony that
                rose and swirled around us like the first soft drops of a summer storm. It was the
                kind of opening that makes you hold your breath without realizing it, and for a
                moment, I thought they might just steal the whole competition.</p>
            <p>Barbara squeezed my arm, her voice barely a whisper. “That’s how you start a show.”</p>

            <p>But as the performance continued, it became clear they’d put all their magic into
                that first song. They sang every “rain” song you could imagine—“Raindrops Keep
                Fallin’ on My Head,” “Purple Rain,” “Here Comes the Rain Again.” They were good,
                but the spell of that opening number was impossible to recreate. It was like trying to
                catch lightning in a bottle twice. Barbara adored it, though. She stayed mesmerized,
                her hand resting lightly on her chest as if she could still feel the music.</p>
            <p>Cora, as always, had her own take. “It was good,” she said, tilting her head in that
                way she does when she’s trying to be polite but honest. “But it didn’t touch Tom’s
                choir, and it sure didn’t have the heart of the Indiana Amish show.” She said it with
                such matter-of-fact certainty that there was no arguing with her, though I could tell
                she wasn’t trying to be critical—just truthful.</p>
            <p>The next group to perform was another California choir, and they took the stage
                with a modern spin on the Mickey Mouse Club. Their harmonies were tight, their
                choreography razor-sharp, and their costumes sparkled under the stage lights. But
                there was something missing. Their faces gave it away—they weren’t having fun.</p>

            <p>They wore those iconic Mickey Mouse ears like they were braces in a middle school
                yearbook photo, plastering on smiles that didn’t quite reach their eyes.</p>
            <p>Cora leaned over, her voice low but wry. “Those kids hated those ears,” she said,
                shaking her head. I bit back a laugh. She wasn’t wrong. No amount of technical
                precision could cover up the fact that their hearts just weren’t in it.</p>
            <p>Then came the final choir of the division, hailing from San Francisco. Their show felt
                less like a competition piece and more like a promotional ad for Airbnb and the Bay
                Area. The backdrop showcased postcard-perfect shots of the Golden Gate Bridge,
                cable cars, and pastel Victorians. Every song was about San Francisco—some I’d
                never even heard of. It was entertaining, sure, but it lacked the gravitas of the other
                groups. It felt like something you’d see at a theme park, pleasant but unremarkable.</p>

            <p>And yet when they sang “Save Me, San Francisco” by Train, I found myself
                unexpectedly moved. That song brought back a memory so vivid I could almost feel
                the soft Charleston sheets beneath me, smell the hint of salt air wafting through the
                window. It was the morning of our 20th anniversary. Frank had surprised me with a
                trip to Charleston, South Carolina, a romantic getaway that felt like a scene out of a
                dream. I woke to find him standing beside the bed, a tray of breakfast in his hands
                and that familiar sparkle in his eye.</p>
            <p>He set the tray down, pulled out his phone, and pressed play. “Hey, Soul Sister”
                started playing, and before I could process what was happening, Frank started
                lip-syncing the words. He swayed his hips, his movements more endearing than
                accurate, grinning at me as he did his very best Train-inspired choreography. I
                laughed so hard I cried, and in that moment, there wasn’t another soul on earth but
                him.</p>
            <p>That memory felt so alive in my chest that I almost didn’t hear the rest of the San
                Francisco choir’s set. Maybe that’s why I enjoyed their performance more than I
                should have. It wasn’t about the quality—it was about the way it transported me, if
                only for a few minutes, back to a moment I’d give anything to relive.</p>

            <p>When the division ended and the judges began their deliberations, Cora handed us
                her score sheet. For someone who spent her days tending cattle in Iowa, her notes
                read like they belonged to a seasoned show choir judge. She had Tom’s choir in first
                place, the Southern California choir in second, San Francisco in third, Arizona in
                fourth, and the Mickey Mouse Club group rounding out the bottom.</p>
            <p>Barbara glanced at the notes and nodded in agreement. “I think you’re right,” she
                said, though she made a case for Arizona taking third over San Francisco. “But we
                can all agree,” she added, a hint of mischief in her tone, “that the Mickey Mouse ears
                weren’t working any magic today.”</p>
            <p>We all laughed, not cruelly but with the kind of shared understanding that comes
                from knowing how much heart goes into these performances, even when they fall
                flat. I couldn’t help but think how much Frank would have loved Cora’s
                straightforwardness and Barbara’s warmth. Sometimes, it’s not the sequins, the fog
                machines, or even the harmonies that linger—it’s the memories we bring with us
                and the people who make those moments worth remembering. And for a few hours,
                in the swirl of music and laughter, I felt like I’d found a little piece of him again.</p>

            <p>It didn’t take long for the MC to return to the stage, his confident stride pulling all
                eyes to him as the head judge handed over the results. The room stilled, a collective
                hush settling over the crowd like the quiet before a storm. With methodical
                precision, the MC began to read the rankings, each word hanging in the air as if it
                were heavy with meaning.</p>
            <p>“Fifth place: the California choir with the Mickey Mouse Club show.” A murmur of
                polite applause rippled through the crowd.</p>
            <p>“Fourth place: the California show choir from San Francisco.” More clapping, though
                the energy in the room seemed to dip slightly.</p>


            <p>“Third place: the show choir from Arizona.” I glanced at Barbara, who gave me a
                small, knowing smile.</p>
            <p>“Second place: the show choir from Indiana.” The crowd erupted, cheers and
                whistles echoing across the auditorium. Cora clapped her hands together and
                muttered, “Good for them. Tom must be thrilled.”</p>
            <p>“And in first place,” the MC continued, pausing for dramatic effect, “the show choir
                from Southern California.”</p>

            <p>The audience roared its approval, but I barely heard it. All I could think was, Damn
                it, Frank. Why do you always have to be right? I could almost hear his voice, that
                teasing lilt he used when he was absolutely certain about something. “Trust me,” he
                would’ve said, grinning like he already knew how it would all turn out.</p>
            <p>Before I could dwell on the bittersweet weight of that thought, my phone buzzed in
                my hand. It was a text from Tom.</p>
            <p><i>We placed exactly where we wanted to be. I know we’re going to make the finals, and
                we’ve got a few surprises up our sleeves for tonight. We’re in the basement behind
                closed doors, practicing like crazy. We’re gonna be stunning this evening, and we’re
                coming home with first place. Oh, and don’t worry about me—they’re feeding us in a
                few. I’m so glad you came. I just wish Dad was here to see this.</i></p>

            <p>My chest tightened as I read his words, and I blinked quickly, trying to keep the
                tears at bay. I texted back, So proud of you. And I believe Dad is here.</p>
            <p>The MC’s voice pulled me back into the present. He had another envelope in his
                hand, the head judge standing beside him with an air of ceremony. “Ladies and
                gentlemen, I have the results for tonight’s finals. Due to a tie in one division, the
                judges have increased the number of finalists from five to six. Here we go.”</p>
            <p>The tension in the room was palpable as he began to read.</p>

            <p>“Kentucky Show Choir performing Over the Moon.”</p>
            <p>Cheers erupted from one corner of the room.</p>
            <p>“Show choir from Iowa performing A Little Bit Country.”</p>


            <p>Cora nudged me, her face lit with excitement.</p>
            <p>“Show choir from California performing Beach Blanket.”</p>
            <p>“Show choir from Mississippi performing Wanna Dance.” Barbara practically leapt
                out of her seat, clapping and shouting, “M-I-S-S-I-S-S-I-P-P-I! That’s Mississippi!”</p>

            <p>“Show choir from Indiana performing Raise the Roof.”</p>
            <p>And then, the final announcement: “Show choir from Southern California
                performing Beetlejuice.”</p>
            <p>The MC glanced at his watch and added, “The finals will begin promptly in one
                hour. By my Apple Watch, that’s 6:37. Doors will close at that time, so please plan
                accordingly. And be careful out there in this surprise Chicago snow.”</p>

            <p>The excitement between the three of us was electric, a barely contained surge of joy.
                Barbara was still chanting “Mississippi” under her breath, her face glowing with
                pride. Cora had grabbed my arm and was shaking me, her voice trembling as she
                said, “I get to see Stoney perform again. This is beyond words. Just... beyond words.”</p>
            <p>As for me, my heart was pounding, but not just from the announcements. I had a
                secret—Tom’s text. Indiana had something planned for tonight, something that
                would blow everyone away. I could feel the anticipation buzzing in my veins, but I
                kept it to myself, savoring the quiet thrill of knowing before anyone else.</p>
            <p>When Barbara finally calmed down, I leaned in and said, “Why don’t we head up to
                my hotel room? We can grab a snack and take a breather before tonight.”</p>

            <p>“Our hotel room,” Barbara corrected with a laugh. “You know we’re not letting you
                out of our sight until this is over.”</p>
            <p>I smiled, feeling a warmth that wasn’t just from the excitement of the evening. In
                that moment, surrounded by friends and the swirl of music and memories, I felt
                Frank’s presence as surely as if he were standing beside me. Tonight wasn’t just
                about the competition; it was about the connections that carried us through—the
                ones we lost and the ones we held onto.</p>
            <p>And as we headed for the door, snow swirling outside like confetti, I knew one thing
                for sure: this night would be unforgettable.</p>





        </div>
    )
}

export default EchoesCH10